// localStorageUtil.js
import CryptoJS from "crypto-js";

export const SECRET_KEY=process.env.REACT_APP_LOCAL_STORAGE_ENCYPTION_KEY;

// Function to encrypt data
const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

// Function to decrypt data
const decryptData = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  if (!decryptedData) {
    throw new Error("Decryption failed or data is malformed");
  }
  return JSON.parse(decryptedData);
};

// Function to set item in localStorage
export const setItem = (key, value) => {
  const encryptedValue = encryptData(value);
  localStorage.setItem(key, encryptedValue);
};

// Function to get item from localStorage
export const getItem = (key) => {
  const encryptedValue = localStorage.getItem(key);
  if (encryptedValue) {
    try {
      return decryptData(encryptedValue);
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null; // or handle the error as needed
    }
  }
  return null; // or return a default value
};

// Function to remove item from localStorage
export const removeItem = (key) => {
  localStorage.removeItem(key);
};

export const AUTH_TOKEN_KEY = "token";
export const setAuthToken = (token) => {
  if (token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  }
};
export const getAuthToken = () => localStorage.getItem(AUTH_TOKEN_KEY);
export const hasAuthToken = () => Boolean(getAuthToken());
export const removeAuthToken = () => localStorage.removeItem(AUTH_TOKEN_KEY);

const BRAND_PREFERENCE_KEYS = ["refBrandId", "theme"];

const preserveBrandPreferences = () =>
  BRAND_PREFERENCE_KEYS.reduce((preserved, key) => {
    const value = getItem(key);
    if (value != null) {
      preserved[key] = value;
    }
    return preserved;
  }, {});

const restoreBrandPreferences = (preserved = {}) => {
  BRAND_PREFERENCE_KEYS.forEach((key) => {
    if (preserved[key] != null) {
      setItem(key, preserved[key]);
    }
  });
};

// Clears auth/session data while keeping the selected brand (refBrandId, theme).
export const clearAuthSession = () => {
  const preservedBrand = preserveBrandPreferences();
  const keysToRemove = [];

  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (key) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
  restoreBrandPreferences(preservedBrand);
};
